import styled from "styled-components";
import { images } from "../../../assets";

export const LabelContainer = styled.label`
  display: block;
  text-transform: uppercase;
  margin-bottom: 5px;

  &.required {
    background: url(${images.Required}) no-repeat 0% 50%;
    background-size: 12px;
    padding: 0 0 0 15px;
  }

  &.old-style {
    margin-top: -5px;
  }
`;
